import { Swiper } from "swiper/bundle";

const Thumbs = document.querySelector(".js-swiper-thumbs");
const playButtons = document.querySelectorAll(".js-play-video");
const videos = document.querySelectorAll(".carousel-popup__video");
const iframes = document.querySelectorAll('.video-player');

export const swiper = new Swiper(".js-swiper", {
  thumbs: {
    swiper: Thumbs,
  },
  spaceBetween: 8,
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  a11y: {
    firstSlideMessage: "Dit is de eerste slide",
    nextSlideMessage: "Naar de volgende slide",
    prevSlideMessage: "Naar de vorige slide",
    lastSlideMessage: "Dit is de laatste slide",
    paginationBulletMessage: "Ga naar slide {{index}}",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  on: {
    slideChange: function () {
      videos.forEach((video, index) => {
        video.pause();
        video.controls = false;
        playButtons[index].style.visibility = "visible";
      });
      
      iframes.forEach(iframe => {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
    },
  },
});
